<template>
  <div>
    <el-dialog
      :title="dialogOption.title"
      :visible.sync="dialogOption.dialogVisible"
      v-el-dialog-drag
      :before-close="close"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form ref="form" :model="formData" :rules="rules" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="节点名称" prop="linePointName">
              <el-input
                clearable
                v-model="formData.linePointName"
                placeholder="请输入节点名称"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="客户名称" prop="custCode">
              <dict-select
                v-model="formData.custCode"
                url="/master/customer/info/select"
                placeholder="请选择客户"
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="省/市/县">
              <region-cascader
                filterable
                :show="regionShow"
                :provinceCode.sync="formData.provinceCode"
                :provinceName.sync="formData.provinceName"
                :cityCode.sync="formData.cityCode"
                :cityName.sync="formData.cityName"
                :districtCode.sync="formData.districtCode"
                :districtName.sync="formData.districtName"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="详细地址" prop="linePointAddress" size="small">
              <el-input
                size="small"
                placeholder="请输入详细地址"
                v-model="formData.linePointAddress"
                :disabled="disabled"
              >
                <el-button
                  slot="append"
                  size="small"
                  icon="el-icon-map-location"
                  @click="coordPickerDialogVisible = true"
                  :disabled="disabled"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="10"> -->

        <!-- <el-col :span="12">
            <el-form-item label="节点距离" prop="distance">
              <el-input-number
                style="width:100%"
                clearable
                v-model="formData.distance"
                :step="10"
                :precision="0"
                :min="0"
                controls-position="right"
                placeholder="请选择节点距离"
              >
              </el-input-number>
            </el-form-item>
          </el-col> -->
        <!-- </el-row> -->

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="节点顺序" prop="sortOrder">
              <el-input-number
                style="width:100%"
                clearable
                v-model="formData.sortOrder"
                :step="1"
                :precision="0"
                :min="1"
                controls-position="right"
                placeholder="请选择节点顺序"
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="收发货方" prop="linePointType">
              <el-radio label="R" v-model="formData.linePointType"
                >收货方</el-radio
              >
              <el-radio label="D" v-model="formData.linePointType"
                >发货方</el-radio
              >
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="有效状态" prop="linePointStatus">
              <el-radio label="Y" v-model="formData.linePointStatus"
                >有效</el-radio
              >
              <el-radio label="N" v-model="formData.linePointStatus"
                >无效</el-radio
              >
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">
          取消
        </el-button>
        <el-button type="primary" @click="save" size="small">保存 </el-button>
      </div>
    </el-dialog>
    <coord-picker-dialog
      v-if="coordPickerDialogVisible"
      :visible.sync="coordPickerDialogVisible"
      :address.sync="formData.linePointAddress"
      :longitude.sync="formData.linePointLongitude"
      :latitude.sync="formData.linePointLatitude"
    />
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button type="primary" size="small" @click="save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coordPickerDialogVisible: false,
      type: '',
      dialogOption: {
        title: '新增',
        dialogVisible: false,
      },
      regionShow: true,
      backDialogVisible: false,
      formData: {
        linePointStatus: 'Y',
        lineCode: this.lineCode,
      },
      rules: {
        linePointName: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
        ],
        linePointAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        // distance: [
        //   { required: true, message: '请选择节点距离', trigger: 'change' },
        // ],
        linePointType: [
          { required: true, message: '请选择收发货方', trigger: 'change' },
        ],
      },
    }
  },

  methods: {
    load(ref, val) {
      this.reset()
      this.type = ref
      if (ref === 'add') {
        this.dialogOption.title = '新增'
      } else if (ref === 'edit') {
        this.dialogOption.title = '编辑'
        this.formData = val
      }
      this.dialogOption.dialogVisible = true
    },

    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let temp = { ...this.formData }
          if (this.type === 'edit') {
            this.$emit('editRowSave', temp)
          } else {
            this.$emit('addRowSave', temp)
          }
          this.close()
        } else {
          return false
        }
      })
    },
    close() {
      this.backDialogVisible = false
      this.dialogOption.dialogVisible = false
    },
    reset() {
      this.type = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.formData = {
        linePointStatus: 'Y',
        lineCode: this.lineCode,
      }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
  },
}
</script>
